module.exports = __webpack_public_path__ + "static/media/icon-surprise.e273a10f.svg";